import { Button, Col, Form, FormGroup, Label, Input } from 'reactstrap';
import { Link } from 'react-router-dom';
// import { SubMateriService } from 'Services/axios/SubMateri.Service';
import { Image } from 'AbstractElements';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import VideoPlayer from 'Component/Learning/DetailSubMateri/VideoPlayer';
import AudioPlayer from 'Component/Learning/DetailSubMateri/AudioPlayer';
import { setField } from 'Features/Learning/SubMateri/addSubMaterialSlice';
import RichEditor from 'Component/Editor/RichEditor/RichEditor';
import Swal from 'sweetalert2';

const FormPost = () => {
  const dispatch = useDispatch()
  const data = useSelector(state => state.addSubMaterial)
  const [isEbookPreviewLoading, setIsEbookPreviewLoading] = useState(false);
  const [isEbookPreviewError, setIsEbookPreviewError] = useState(false);

  // Normalisasi link Google Drive agar format /view bisa dipreview dengan /preview.
  // const getGoogleDrivePreviewLink = (link = '') => {
  //   if (!link) return '';

  //   const driveFileRegex = /^https?:\/\/drive\.google\.com\/file\/d\/([^/]+)\/(view|preview)(\?.*)?$/i;
  //   const matched = link.match(driveFileRegex);

  //   if (!matched) return link;

  //   const fileId = matched[1];
  //   return `https://drive.google.com/file/d/${fileId}/preview`;
  // };

  // Gunakan link yang sedang diketik, lalu fallback ke link existing saat mode update.
  const ebookPreviewLink = data.type === 'ebook'
    ? (data.link || data.linkFile)
    : '';

  useEffect(() => {
    // Reset state preview setiap kali link e-book berubah agar admin dapat status terbaru.
    if (data.type === 'ebook' && ebookPreviewLink) {
      setIsEbookPreviewLoading(true);
      setIsEbookPreviewError(false);
    } else {
      setIsEbookPreviewLoading(false);
      setIsEbookPreviewError(false);
    }
  }, [data.type, ebookPreviewLink]);

  const handleEbookPreviewLoad = () => {
    // Hentikan loading ketika iframe berhasil dimuat.
    setIsEbookPreviewLoading(false);
    setIsEbookPreviewError(false);
  };

  const handleEbookPreviewError = () => {
    // Tampilkan indikator gagal jika iframe tidak dapat dimuat.
    setIsEbookPreviewLoading(false);
    setIsEbookPreviewError(true);
  };

  const handleChanges = (e) => {
    const { name, value } = e.target;
    dispatch(setField({ field: name, value: value }));
    // check if type is changed then reset link and file
    if (name === 'type') {
      dispatch(setField({ field: 'link', value: '' }));
      dispatch(setField({ field: 'linkFile', value: '' }));
      dispatch(setField({ field: 'file', value: null }));
      if (data.isUpdate) {
        Swal.fire({
          icon: 'warning',
          title: 'Perhatian',
          text: 'Anda telah mengubah tipe, pastikan untuk mengisi kembali link atau file yang sesuai dengan tipe yang dipilih.',
        })
      }
    }
  };

  const handleChangeDescription = (e) => {
    dispatch(setField({ field: 'description', value: e }));
  }

  return (
    <>
      <Form className="row needs-validation">
        <Col sm="12" className="pb-5">
          <FormGroup className='mb-3'>
            <Label for="validationImage" style={{ fontWeight: 'bold' }}>{'Judul'}:</Label>
            <Input className="form-control" id="validationCustom01" type="text" name="name" placeholder="Judul Submateri" required=""
              value={data.name}
              onChange={handleChanges} />
            <div className="valid-feedback">{'Looks good!'}</div>
          </FormGroup>
          <FormGroup className='mb-3'>
            <Label for="validationImage" style={{ fontWeight: 'bold' }}>{'Tipe'}:</Label>
            <div className="m-checkbox-inline">
              <Label for="type_image">
                <Input className="radio_animated" id="type_image" type="radio" name="type" value="image"
                  checked={data.type == 'image'}
                  onChange={handleChanges} />{'Gambar'}
              </Label>
              <Label for="type_youtube">
                <Input className="radio_animated" id="type_youtube" type="radio" name="type" value="youtube"
                  checked={data.type == 'youtube'}
                  onChange={handleChanges} />{'Youtube'}
              </Label>
              <Label for="type_video">
                <Input className="radio_animated" id="type_video" type="radio" name="type" value="video"
                  checked={data.type == 'video'}
                  onChange={handleChanges} />{'Video'}
              </Label>
              <Label for="type_ebook">
                <Input className="radio_animated" id="type_ebook" type="radio" name="type" value="ebook"
                  checked={data.type == 'ebook'}
                  onChange={handleChanges} />{'E-book'}
              </Label>
              <Label for="type_audio">
                <Input className="radio_animated" id="type_audio" type="radio" name="type" value="audio"
                  checked={data.type == 'audio'}
                  onChange={handleChanges} />{'Audio'}
              </Label>
            </div>
          </FormGroup>
          <FormGroup className='mb-3'>
            <Label for="validationImage" style={{ fontWeight: 'bold' }}>{'Deskripsi'}:</Label>
            <RichEditor handleChangeDescription={handleChangeDescription} description={data.description} />
          </FormGroup>
          {(data.type == 'youtube' || data.type == 'ebook') &&
            <FormGroup className='mb-3'>
              <Label for="validationImage" style={{ fontWeight: 'bold' }}>{'Link'}</Label>
              <Input className="form-control" type="url" name="link" placeholder={data.type == 'youtube' ? 'Youtube Embed Link' : 'E-book Link'}
                value={data.link}
                onChange={handleChanges} />
              {data.type === 'ebook' && (
                <>
                  {/* Informasi format link Google Drive agar admin tahu pola yang wajib dipakai. */}
                  <small className="text-muted d-block mt-2">
                    Untuk Google Drive, ubah link dari <strong>/view?usp=sharing</strong> menjadi <strong>/preview</strong> agar bisa di-embed.
                  </small>
                  <small className="text-muted d-block">
                    Contoh: https://drive.google.com/file/d/18Oe-B75-7rRDJ7ZbX5JC-ny51D32PPtN/view?usp=sharing → https://drive.google.com/file/d/18Oe-B75-7rRDJ7ZbX5JC-ny51D32PPtN/preview
                  </small>
                </>
              )}
            </FormGroup>
          }
        </Col>
      </Form>

      {(data.type === 'ebook' && ebookPreviewLink !== '') && (
        <FormGroup className='mb-3'>
          <Label for="validationImage" style={{ fontWeight: 'bold' }}>Preview E-book:</Label>
          {isEbookPreviewLoading && (
            <div className="d-flex align-items-center gap-2 mb-2">
              <div className="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></div>
              <small className="text-muted">Sedang memuat preview e-book...</small>
            </div>
          )}
          {isEbookPreviewError && (
            <small className="text-danger d-block mb-2">
              Preview e-book gagal dimuat. Pastikan link valid dan file dapat diakses.
            </small>
          )}
          <div className="embed-responsive embed-responsive-16by9">
            <iframe
              width="720"
              height="480"
              src={ebookPreviewLink}
              title="Google Drive E-book Preview"
              frameBorder="0"
              allow="autoplay"
              onLoad={handleEbookPreviewLoad}
              onError={handleEbookPreviewError}
              style={{ opacity: isEbookPreviewLoading ? 0.7 : 1 }}
            ></iframe>
          </div>
        </FormGroup>
      )}

      {(data.isUpdate === true && data.type === 'video' && data.linkFile !== '') && (
        <FormGroup className='mb-3'>
          <Label for="validationImage" style={{ fontWeight: 'bold' }}>Video:</Label>
          <VideoPlayer link={data.linkFile} width={720} />
        </FormGroup>
      )}
      {(data.isUpdate === true && data.type === 'audio' && data.linkFile !== '') && (
        <FormGroup className='mb-3'>
          <Label for="validationImage" style={{ fontWeight: 'bold' }}>Audio:</Label>
          <AudioPlayer link={data.linkFile} />
        </FormGroup>
      )}
      {(data.isUpdate === true && data.type === 'image' && data.linkFile !== '') && (
        <FormGroup className='mb-3'>
          <Label for="validationImage" style={{ fontWeight: 'bold' }}>Gambar:</Label>
          <div className="embed-responsive embed-responsive-16by9">
            <Image attrImage={{ className: 'img-fluid', src: data.linkFile, width: '500px', alt: data.name }} />
          </div>
        </FormGroup>
      )}
      {(data.isUpdate === true && data.type === 'ebook' && data.linkFile !== '') && (
        <FormGroup className='mb-3'>
          <Label for="validationImage" style={{ fontWeight: 'bold' }}>E-book:</Label>
          <div className="embed-responsive embed-responsive-16by9">
            <Link to={ebookPreviewLink} target="_blank">
              <Button color="primary" className="btn-block">Buka</Button>
            </Link>
          </div>
        </FormGroup>
      )}
      {(data.isUpdate === true && data.type === 'youtube' && data.linkFile !== '') && (
        <FormGroup className='mb-3'>
          <Label for="validationImage" style={{ fontWeight: 'bold' }}>Youtube:</Label>
          <div className="embed-responsive embed-responsive-16by9">
            <iframe width="560" height="315" src={data.linkFile} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
          </div>
        </FormGroup>
      )}
    </>
  );
};
export default FormPost;